import './TickerSeparator.css';

export const TickerSeparator = () => {
    return <div className="separator">:</div>;
}